import { getIsOrderEditable } from '@app/logic/Orders';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { isEmpty } from '../isEmpty';

import { useOrderStatusLabels } from './useOrderStatusLabels';

export const useOrderStatusList = () => {
  const { t } = useTranslation(['orders']);
  const orderStatusLabels = useOrderStatusLabels();
  const all = React.useMemo(
    () =>
      [
        { name: t('orders:stage_all'), value: '' },
        { name: orderStatusLabels.open, value: 'open' },
        { name: orderStatusLabels.checkoutRequested, value: 'checkoutRequested' },
        { name: orderStatusLabels.pending, value: 'pending' },
        { name: orderStatusLabels.inProgress, value: 'inProgress' },
        { name: orderStatusLabels.completed, value: 'completed' },
        { name: orderStatusLabels.cancelled, value: 'cancelled' },
      ] as const,
    [orderStatusLabels, t],
  );

  const editable = React.useMemo(() => all.filter(stage => isEmpty(stage.value) || getIsOrderEditable(stage.value)), [all]);
  const notEditable = React.useMemo(() => all.filter(stage => isEmpty(stage.value) || !getIsOrderEditable(stage.value)), [all]);

  return {
    all,
    editable,
    notEditable,
  };
};
